import ActionType from '../action-types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  currency: '',
  totalGasToday: 0,
  stationName: '',
  thisMonth: 0,
  totalGasMonth: 0,
  totalSalesMonth: 0,
  totalSalesToday: 0,
  salesGraph: [],
  totalUnapproved: 0,
  recentApproved: []
};

// eslint-disable-next-line default-param-last
const DashBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCH_DASHBOARD_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        currency: '',
        totalGasToday: 0,
        thisMonth: 0,
        totalGasMonth: 0,
        totalSalesMonth: 0,
        totalSalesToday: 0,
        salesGraph: [],
        totalUnapproved: 0,
        recentApproved: []
      };
    case ActionType.FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        currency: action.payload.currency,
        stationName: action.payload.station_name,
        totalGasToday: action.payload.total_gas_today,
        thisMonth: action.payload.this_month,
        totalGasMonth: action.payload.total_gas_month,
        totalSalesMonth: action.payload.total_sales_month,
        totalSalesToday: action.payload.total_sales_today,
        salesGraph: action.payload.sales_graph,
        totalUnapproved: action.payload.total_unapproved,
        recentApproved: action.payload.recent_approved
      };
    case ActionType.FETCH_DASHBOARD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        currency: '',
        totalGasToday: 0,
        thisMonth: 0,
        totalGasMonth: 0,
        totalSalesMonth: 0,
        totalSalesToday: 0,
        salesGraph: [],
        totalUnapproved: 0,
        recentApproved: []
      };
    default:
      return state;
  }
};

export default DashBoardReducer;
